class Events {
  constructor() {
    this.events = {};
  }

  on(eventName, callback) {
    if (!callback || typeof callback !== 'function') {
      return;
    }

    this.events[eventName] = this.events[eventName] || [];
    this.events[eventName].push(callback);

    return () => {
      this.off(eventName, callback);
    };
  }

  once(eventName, callback) {
    if (!callback || typeof callback !== 'function') {
      return;
    }

    var off = this.on(eventName, function(...params) {
      callback(...params);
      off();
    });
  }

  trigger(eventName, ...params) {
    var callbacks = [];
    if (this.events && this.events[eventName] && this.events[eventName].length > 0) {
      callbacks = this.events[eventName];
    }

    callbacks.forEach(callback => callback(...params));
  }

  off(eventName, callback = undefined) {
    if (this.events[eventName] && this.events[eventName].length > 0) {
      if (callback) {
        removeItem(this.events[eventName], callback);
      } else {
        this.events[eventName] = [];
      }
    }
  }
}

function removeItem(arr, item) {
  var index = arr.indexOf(item);
  if (index !== -1) {
    arr.splice(index, 1);
  }
}

export default Events;
